export const POINT_OF_SALE_TTL_ES = 'Punto de Venta';
export interface IPointOfSaleBase {
  branchStoreId: number;
  code: string;
  seriesOfReceipts: number;
}
export interface IPointOfSale extends IPointOfSaleBase {
  id: number;
}
export type IPointOfSaleUpdate = Partial<IPointOfSaleBase>;
